// ComunicacionEmpresas — /admin/comunicacion/empresas
// El Agente de Empresas (B2B) — NUEVO 26-jul-2026.
// REGLA DEL FUNDADOR: B2B NO va por Instagram (un administrador de edificios no
// compra por IG). Canales: Google (Ads + Business Profile), contacto directo
// (mail/WhatsApp/visita) y volantes en administradoras.
// El agente (edge fn agente-empresas, Sonnet 4.6, martes 09:00) propone piezas
// en piezas_b2b con estado='propuesto': mails de prospección, briefs de pauta
// B2B, guiones de volante, posts GBP. Acá Nico aprueba/rechaza (el rechazo con
// motivo alimenta el loop de aprendizaje, patrón feedback_gerente) y copia el
// texto listo para mandar. El brief permanente vive en app_config.playbook_b2b.

import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import AdminLayout from '../../components/AdminLayout'
import { supabase } from '../../lib/supabase'
import { AGENTES_COM, AgenteHero, COM_CSS } from '../../components/comunicacion/ComunicacionUI'

const SUPA_URL = import.meta.env.VITE_SUPABASE_URL

const TIPO_LABEL = {
  email_prospeccion: '📧 Mail de prospección',
  brief_pauta: '🎯 Brief de pauta (Google)',
  volante_admin: '📄 Volante administradoras',
  gbp_post: '📍 Post Google Business',
  whatsapp_b2b: '💬 WhatsApp B2B',
  otro: '🔖 Otro',
}

export default function ComunicacionEmpresas() {
  const [loading, setLoading] = useState(true)
  const [tablaExiste, setTablaExiste] = useState(true)
  const [ultimoRun, setUltimoRun] = useState(null)
  const [piezas, setPiezas] = useState([])
  const [tab, setTab] = useState('propuesto')
  const [kpis, setKpis] = useState({ consultas30d: 0, pipeline: {}, activas: 0 })
  const [playbook, setPlaybook] = useState('')
  const [editandoPlaybook, setEditandoPlaybook] = useState(false)
  const [generando, setGenerando] = useState(false)
  const [briefManual, setBriefManual] = useState('')
  const [msg, setMsg] = useState(null)
  const [abierta, setAbierta] = useState(null)

  useEffect(() => { cargar() }, [])

  async function cargar() {
    setLoading(true)
    try {
      const { data: runs } = await supabase
        .from('agentes_runs').select('created_at')
        .eq('agente', 'agente-empresas').order('created_at', { ascending: false }).limit(1)
      setUltimoRun(runs?.[0]?.created_at || null)

      const r = await supabase
        .from('piezas_b2b')
        .select('id, tipo, segmento, titulo, asunto, cuerpo, cta, estado, feedback, created_at, modelo')
        .order('created_at', { ascending: false }).limit(60)
      if (r.error) { setTablaExiste(false); setPiezas([]) }
      else { setTablaExiste(true); setPiezas(r.data || []) }

      const hace30 = new Date(Date.now() - 30 * 86400000).toISOString()
      const [consR, empR] = await Promise.all([
        supabase.from('consultas_comerciales').select('id', { count: 'exact', head: true }).gte('created_at', hace30),
        supabase.from('empresas').select('estado_pipeline').is('archivada_at', null),
      ])
      const pipeline = {}
      ;(empR.data || []).forEach(e => { pipeline[e.estado_pipeline] = (pipeline[e.estado_pipeline] || 0) + 1 })
      setKpis({ consultas30d: consR.count || 0, pipeline, activas: pipeline.activo || 0 })

      const { data: pb } = await supabase.from('app_config').select('value').eq('key', 'playbook_b2b').maybeSingle()
      setPlaybook(pb?.value || '')
    } catch (e) {
      console.error('ComunicacionEmpresas cargar:', e)
    } finally {
      setLoading(false)
    }
  }

  async function generar(conBrief) {
    const brief = conBrief ? briefManual.trim() : ''
    if (conBrief && !brief) { setMsg({ tipo: 'err', texto: 'Escribí el pedido puntual primero.' }); return }
    if (!conBrief && !confirm('¿Pedirle al Agente de Empresas sus propuestas B2B ahora?\n\nLee el playbook B2B + banco de ángulos + pipeline real + tus rechazos y propone 3-5 piezas (mails, pauta Google, volantes). Toma 1-2 minutos.')) return
    setGenerando(true); setMsg(null)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const token = session?.access_token
      if (!token) throw new Error('Sin sesión activa')
      const r = await fetch(`${SUPA_URL}/functions/v1/agente-empresas`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(brief ? { brief } : {}),
      })
      const json = await r.json()
      if (!r.ok || json.error) throw new Error(json.error || `HTTP ${r.status}`)
      setMsg({ tipo: 'ok', texto: json.skip ? json.resumen : `✓ ${json.piezas_propuestas} propuestas B2B (${json.modelo}). ${(json.resumen || '').slice(0, 180)}` })
      setBriefManual('')
      await cargar()
    } catch (e) {
      setMsg({ tipo: 'err', texto: e.message })
    } finally {
      setGenerando(false)
    }
  }

  async function aprobar(id) {
    const { data: { user } } = await supabase.auth.getUser()
    if (!user) { alert('Sesión expirada'); return }
    const { error } = await supabase.from('piezas_b2b')
      .update({ estado: 'aprobado', aprobado_at: new Date().toISOString(), aprobado_por: user.id, updated_at: new Date().toISOString() })
      .eq('id', id)
    if (error) { alert('Error: ' + error.message); return }
    await cargar()
  }

  async function rechazar(id) {
    const motivo = prompt('¿Por qué rechazás? (queda guardado: el agente aprende de esto)')
    if (motivo === null) return
    const pieza = piezas.find(p => p.id === id)
    const prev = pieza?.feedback || []
    const { error } = await supabase.from('piezas_b2b')
      .update({ estado: 'descartado', feedback: [...prev, motivo || '(sin motivo)'], updated_at: new Date().toISOString() })
      .eq('id', id)
    if (error) { alert('Error: ' + error.message); return }
    await cargar()
  }

  async function marcarEnviado(id) {
    const { error } = await supabase.from('piezas_b2b')
      .update({ estado: 'enviado', updated_at: new Date().toISOString() }).eq('id', id)
    if (error) { alert('Error: ' + error.message); return }
    await cargar()
  }

  async function copiar(pieza) {
    const texto = (pieza.asunto ? `Asunto: ${pieza.asunto}\n\n` : '') + pieza.cuerpo + (pieza.cta ? `\n\n${pieza.cta}` : '')
    try {
      await navigator.clipboard.writeText(texto)
      setMsg({ tipo: 'ok', texto: '✓ Copiado al portapapeles.' })
    } catch {
      setMsg({ tipo: 'err', texto: 'No se pudo copiar — seleccioná el texto a mano.' })
    }
  }

  async function guardarPlaybook() {
    const { error } = await supabase.from('app_config')
      .update({ value: playbook, updated_at: new Date().toISOString() }).eq('key', 'playbook_b2b')
    if (error) { setMsg({ tipo: 'err', texto: error.message }); return }
    setMsg({ tipo: 'ok', texto: '✓ Playbook B2B guardado. El agente lo usa en la próxima corrida.' })
    setEditandoPlaybook(false)
  }

  const visibles = piezas.filter(p => tab === 'todas' ? true : p.estado === tab)
  const nPropuestas = piezas.filter(p => p.estado === 'propuesto').length

  return (
    <AdminLayout title="Agente de Empresas">
      <div className="com-wrap">
        <AgenteHero
          agente={AGENTES_COM.empresas}
          ultimaCorrida={ultimoRun}
          extra={<span>· 🔒 Nada se manda solo: vos aprobás, copiás y enviás</span>}
        />

        {msg && <div className={`com-msg ${msg.tipo === 'ok' ? 'com-msg-ok' : 'com-msg-err'}`}>{msg.texto}</div>}

        {!tablaExiste && (
          <div className="com-msg com-msg-err">
            La tabla piezas_b2b todavía no existe: corré la migración 20260726180000 y deployá la edge function agente-empresas.
          </div>
        )}

        {/* KPIs B2B */}
        <div className="come-kpis">
          <div className="come-kpi">
            <div className="come-kpi-num">{kpis.activas}</div>
            <div className="come-kpi-lbl">empresas activas · meta 5 en 90d</div>
          </div>
          <div className="come-kpi">
            <div className="come-kpi-num">{kpis.consultas30d}</div>
            <div className="come-kpi-lbl">cotizaciones 30d · meta 8</div>
          </div>
          <div className="come-kpi">
            <div className="come-kpi-num">{Object.entries(kpis.pipeline).filter(([k]) => ['prospect', 'cotizando', 'negociando'].includes(k)).reduce((s, [, v]) => s + v, 0)}</div>
            <div className="come-kpi-lbl">en pipeline (prospect/cotizando/negociando)</div>
          </div>
          <div className="come-kpi">
            <div className="come-kpi-num">USD 2,40</div>
            <div className="come-kpi-lbl">pauta B2B / día (30% de 8)</div>
          </div>
        </div>

        {/* GENERAR */}
        <section className="com-card" style={{ borderLeft: '4px solid #C5A059' }}>
          <div className="com-card-head">
            <h2 className="com-card-title">✨ Pedirle trabajo al agente</h2>
            <button onClick={() => generar(false)} disabled={generando || !tablaExiste} className="com-btn com-btn-primary">
              {generando ? 'El agente está trabajando…' : '💼 Generar propuestas B2B'}
            </button>
          </div>
          <div className="come-brief">
            <textarea
              rows={2}
              value={briefManual}
              onChange={e => setBriefManual(e.target.value)}
              placeholder='Pedido puntual (opcional). Ej: "Mail para administradoras de Pocitos ofreciendo cotización sin compromiso para los edificios que administran".'
            />
            <button onClick={() => generar(true)} disabled={generando || !tablaExiste} className="com-btn com-btn-ghost">Enviar pedido puntual</button>
          </div>
          <div className="com-card-sub" style={{ marginTop: 8 }}>
            Recordatorio: B2B se trabaja por Google, mail directo, WhatsApp, visitas y volantes en administradoras.
            El agente tiene prohibido proponer posts de Instagram. Empresas del CRM: <Link to="/admin/empresas">/admin/empresas →</Link>
          </div>
        </section>

        {/* COLA DE PIEZAS */}
        <section className="com-card">
          <div className="com-card-head">
            <h2 className="com-card-title">✋ Piezas B2B {nPropuestas > 0 ? `· ${nPropuestas} esperan tu OK` : ''}</h2>
            <div className="come-tabs">
              {['propuesto', 'aprobado', 'enviado', 'todas'].map(t => (
                <button key={t} onClick={() => setTab(t)} className={`come-tab ${tab === t ? 'active' : ''}`}>
                  {t === 'propuesto' ? `Propuestas (${nPropuestas})` : t.charAt(0).toUpperCase() + t.slice(1)}
                </button>
              ))}
            </div>
          </div>
          {loading && <div className="com-empty">Cargando…</div>}
          {!loading && visibles.length === 0 && (
            <div className="com-empty">
              <strong>Nada acá.</strong>
              {tab === 'propuesto' ? 'Pedile propuestas con el botón de arriba (o esperá el cron del martes 09:00).' : 'Sin piezas en este estado.'}
            </div>
          )}
          <div className="come-lista">
            {visibles.map(p => (
              <div key={p.id} className={`come-pieza ${p.estado === 'propuesto' ? 'come-pieza-pend' : ''}`}>
                <div className="come-pieza-head" onClick={() => setAbierta(abierta === p.id ? null : p.id)}>
                  <span className="come-pieza-tipo">{TIPO_LABEL[p.tipo] || p.tipo}</span>
                  {p.segmento && p.segmento !== 'general' && <span className="com-pill com-pill-gray">{p.segmento}</span>}
                  <span className="come-pieza-titulo">{p.titulo}</span>
                  <span className={`com-pill ${p.estado === 'propuesto' ? 'com-pill-gold' : p.estado === 'aprobado' ? 'com-pill-green' : p.estado === 'enviado' ? 'com-pill-teal' : 'com-pill-red'}`}>{p.estado}</span>
                  <span className="come-pieza-chev">{abierta === p.id ? '▾' : '▸'}</span>
                </div>
                {abierta === p.id && (
                  <div className="come-pieza-body">
                    {p.asunto && <div className="come-pieza-asunto">Asunto: <strong>{p.asunto}</strong></div>}
                    <pre className="come-pieza-cuerpo">{p.cuerpo}</pre>
                    {p.cta && <div className="come-pieza-cta">CTA: {p.cta}</div>}
                    {(p.feedback || []).length > 0 && (
                      <div className="come-pieza-fb">Feedback previo: {(p.feedback || []).join(' · ')}</div>
                    )}
                    <div style={{ display: 'flex', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
                      {p.estado === 'propuesto' && <button onClick={() => aprobar(p.id)} className="com-btn com-btn-green">Aprobar</button>}
                      {p.estado === 'propuesto' && <button onClick={() => rechazar(p.id)} className="com-btn com-btn-danger">✕ Rechazar</button>}
                      {p.estado === 'aprobado' && <button onClick={() => marcarEnviado(p.id)} className="com-btn com-btn-primary">Marcar como enviado / publicado</button>}
                      <button onClick={() => copiar(p)} className="com-btn com-btn-ghost">📋 Copiar texto</button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* PLAYBOOK B2B */}
        <section className="com-card">
          <div className="com-card-head">
            <h2 className="com-card-title">📖 Brief permanente del agente (playbook B2B)</h2>
            {!editandoPlaybook
              ? <button onClick={() => setEditandoPlaybook(true)} className="com-btn com-btn-ghost" disabled={!playbook && !tablaExiste}>Editar</button>
              : (
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={guardarPlaybook} className="com-btn com-btn-green">Guardar</button>
                  <button onClick={() => { setEditandoPlaybook(false); cargar() }} className="com-btn com-btn-ghost">Cancelar</button>
                </div>
              )}
          </div>
          {!playbook && !editandoPlaybook && (
            <div className="com-empty"><strong>Sin playbook cargado.</strong>Se seedea con la migración 20260726180000 (app_config.playbook_b2b).</div>
          )}
          {playbook && !editandoPlaybook && <pre className="come-playbook">{playbook}</pre>}
          {editandoPlaybook && (
            <textarea className="come-playbook-edit" rows={14} value={playbook} onChange={e => setPlaybook(e.target.value)} />
          )}
        </section>
      </div>

      <style>{COM_CSS}</style>
      <style>{`
        .come-kpis { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
        @media (max-width: 800px) { .come-kpis { grid-template-columns: repeat(2, 1fr); } }
        .come-kpi { background: #fff; border: 1px solid #E5E7EB; border-radius: 12px; padding: 12px; text-align: center; }
        .come-kpi-num { font-size: 22px; font-weight: 900; color: #1A3461; }
        .come-kpi-lbl { font-size: 10.5px; color: #6B7280; margin-top: 3px; }
        .come-brief { display: flex; gap: 8px; align-items: flex-start; }
        .come-brief textarea {
          flex: 1; border: 1px solid #E2E8F0; border-radius: 8px; padding: 8px 10px;
          font-size: 12.5px; font-family: inherit; resize: vertical;
        }
        .come-tabs { display: flex; gap: 4px; }
        .come-tab {
          border: 1px solid #E2E8F0; background: #fff; border-radius: 999px;
          padding: 4px 12px; font-size: 11.5px; font-weight: 700; color: #64748B;
          cursor: pointer; font-family: inherit;
        }
        .come-tab.active { background: #1A3461; border-color: #1A3461; color: #fff; }
        .come-lista { display: flex; flex-direction: column; gap: 8px; }
        .come-pieza { border: 1px solid #EDF0F4; border-radius: 10px; overflow: hidden; }
        .come-pieza-pend { border-color: #E9DFC8; background: #FFFDF7; }
        .come-pieza-head {
          display: flex; align-items: center; gap: 8px; padding: 10px 12px;
          cursor: pointer; flex-wrap: wrap;
        }
        .come-pieza-tipo { font-size: 12px; font-weight: 800; color: #1A3461; white-space: nowrap; }
        .come-pieza-titulo { flex: 1; font-size: 12.5px; color: #374151; min-width: 160px; }
        .come-pieza-chev { color: #94A3B8; font-size: 11px; }
        .come-pieza-body { padding: 0 14px 12px; border-top: 1px dashed #E5E7EB; }
        .come-pieza-asunto { font-size: 12.5px; color: #374151; margin-top: 10px; }
        .come-pieza-cuerpo {
          white-space: pre-wrap; font-family: inherit; font-size: 12.5px; color: #111827;
          background: #F9FAFB; border: 1px solid #EDF0F4; border-radius: 8px;
          padding: 10px 12px; margin-top: 8px; line-height: 1.55; max-height: 340px; overflow-y: auto;
        }
        .come-pieza-cta { font-size: 12px; color: #00666B; font-weight: 700; margin-top: 6px; }
        .come-pieza-fb { font-size: 11px; color: #991B1B; background: #FEF2F2; border-radius: 6px; padding: 6px 8px; margin-top: 6px; }
        .come-playbook {
          white-space: pre-wrap; font-family: inherit; font-size: 12px; color: #374151;
          background: #F8F6F1; border: 1px solid #E9E5DA; border-radius: 8px;
          padding: 12px 14px; line-height: 1.55; max-height: 300px; overflow-y: auto; margin: 0;
        }
        .come-playbook-edit {
          width: 100%; border: 1px solid #00A8B5; border-radius: 8px; padding: 12px 14px;
          font-size: 12px; font-family: inherit; line-height: 1.55; resize: vertical;
        }
      `}</style>
    </AdminLayout>
  )
}
